import React from 'react'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import autobind from 'autobind-decorator'
import { Form, Field } from 'simple-react-form'
import styles from './styles.css'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Button from 'orionsoft-parts/lib/components/Button'
import HasTwoFactorIcon from 'react-icons/lib/md/lock'
import PropTypes from 'prop-types'
import MdHelp from 'react-icons/lib/md/help'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

@withGraphQL(gql`
  query getUserTwoFactor {
    me {
      _id
      hasTwoFactor
    }
  }
`)
@withMutation(gql`
  mutation enable {
    generateTwoFactorSecret {
      base32
      qrCode
    }
  }
`)
@withMutation(gql`
  mutation disableTwoFactor($userId: ID!) {
    disableTwoFactor(userId: $userId) {
      success
    }
  }
`)
@withMutation(gql`
  mutation complete($code: String!) {
    activateTwoFactor(code: $code) {
      _id
      hasTwoFactor
    }
  }
`)
export default class TwoFactor extends React.Component {
  static propTypes = {
    me: PropTypes.func,
    enable: PropTypes.func,
    complete: PropTypes.func,
    disableTwoFactor: PropTypes.func
  }

  state = {}

  @autobind
  async enable() {
    this.setState({ loading: true })
    try {
      const {
        generateTwoFactorSecret: { base32, qrCode }
      } = await this.props.enable()
      this.setState({ base32, qrCode })
    } catch (error) {
      console.log('Error:', error)
    }
    this.setState({ loading: false })
  }

  @autobind
  async complete() {
    this.setState({ loading: true, errorMessage: '' })
    try {
      await this.props.complete({ code: this.state.code })
    } catch (error) {
      console.log('Error:', error)
      this.setState({
        errorMessage: error.message.replace('GraphQL2 error: ', '')
      })
    }
    this.setState({ loading: false })
  }

  @autobind
  async updateTwoFactor() {
    this.setState({ loading: true, errorMessage: '' })
    try {
      await this.props.complete({ code: this.state.code })
      await this.props.disableTwoFactor({userId: this.props.me._id})
    } catch (error) {
      console.log('Error:', error)
      this.setState({
        errorMessage: error.message.replace('GraphQL error: ', '')
      })
    }
    this.setState({ loading: false })
    window.location.href = '/settings/security'
  }

  renderHasTwoFactor() {
    return (
      <div className={styles.container}>
        <HasTwoFactorIcon size={28} className={styles.twoFactorActivatedIcon} />
        <span className={styles.twoFactorActivatedText}>
          Autentificación de dos factores activada
        </span>
        <div className={styles.yourAccountIsSecure}>
          Tu cuenta es mas segura
        </div>
        <Form state={this.state} onChange={changes => this.setState(changes)}>
          <Field
            errorMessage={this.state.errorMessage}
            fieldName="code"
            placeholder="XXX XXX"
            type={Text}
          />
        </Form>
        <br />
        <Button
          // className={styles.desactivar}
          danger
          disabled={!this.state.code}
          loading={this.state.loading}
          onClick={this.updateTwoFactor}
        >
          Quitar twoFactor
        </Button>
         {/* <Button
          className={styles.desactivar}
          loading={this.state.loading}
          onClick={this.updateTwoFactor}
        >
          Quitar twoFactor
        </Button> */}
      </div>
    )
  }

  renderActivate() {
    return (
      <div>
        <p className={styles.instructionStep}>
          1. Descarga la aplicación de autentificación en el AppStore o
          PlayStore
        </p>
        <div>
          <a
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className={styles.googleIcon}
              src="https://tufirma-prod.s3.amazonaws.com/logos/icono-disponible-google-play.png"
              alt="Play store"
            />
          </a>
          <a
            href="https://apps.apple.com/cl/app/google-authenticator/id388497605"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className={styles.appStoreIcon}
              src="https://tufirma-prod.s3.amazonaws.com/logos/icono-disponible-app-store.png"
              alt="AppStore"
            />
          </a>
        </div>
        <p className={styles.instructionStep}>
          2. Escanea este QR con tu aplicación de autentificación
        </p>
        <div
          style={{ width: 250 }}
          dangerouslySetInnerHTML={{ __html: this.state.qrCode }}
        />
        <p className={styles.addManually}>
          O agrega manualmente el código{' '}
          <code className={styles.addManuallyPre}>{this.state.base32}</code>
        </p>
        <br />
        <p className={styles.instructionStep}>
          3. Escribe el código de 6 dígitos que aparece en tu aplicación para
          confirmar
        </p>
        <Form state={this.state} onChange={changes => this.setState(changes)}>
          <Field
            errorMessage={this.state.errorMessage}
            fieldName="code"
            placeholder="XXX XXX"
            type={Text}
          />
        </Form>
        <br />
        <Button
          disabled={!this.state.code}
          loading={this.state.loading}
          primary
          onClick={this.complete}
        >
          Confirmar
        </Button>
      </div>
    )
  }

  renderContent() {
    if (this.props.me.hasTwoFactor) return this.renderHasTwoFactor()
    if (this.state.base32) return this.renderActivate()
    return (
      <div>
        <div>
          La autenticación de dos factores agrega una capa extra de seguridad a
          tu cuenta
        </div>
        <p>Activar la autentificación de dos factores</p>
        <Button
          primary
          loading={this.state.loading}
          className={styles.activar}
          onClick={this.enable}
        >
          Activar
        </Button>
      </div>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <h3 className={styles.title}>
                  Autentificación de dos factores
                </h3>
              </div>
              <div className="col-xs-12 col-sm-8 end-md">
                <Tooltip content="Digipass para Smartphones">
                  <MdHelp size={20} style={{ paddingTop: 5 }} />
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="content">{this.renderContent()}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Security/TwoFactor/index.js